/**
 * Setting that gates all changes related to Standardizing Order Numbers (see #feature-standardize-order-numbers)
 */
export const RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812 = 'RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812';
